export const shouldHideWidget = (pathname: string): boolean => {
  const hiddenPages: (string | RegExp)[] = [
    "/single-class/",
    "/additional-single-class/",
    "/summer-boost",
    "/winter-math-boost",
    "/booking/",
    "/parents/coppa",
    "/parents/classesMobile",
    "/search",
    new RegExp("/student-session/.*"),
    new RegExp("/tutor/session/.*"),
    new RegExp("/tutor/profile/.*"),
    /\/chats(?:\/|$)/,
    /^\/course\/[^/]+\/?$/,
  ];
  return hiddenPages.some((page) => {
    if (page instanceof RegExp) return page.test(pathname);

    return pathname.includes(page);
  });
};
